'use client';

import { useEffect, useState } from 'react';
import { formatNumberDefault } from '@/utils/numbers/format-number';

type ValueTickerProps = {
    prevAmount: number;
    amount: number;
    incrementTime?: number;
    periodTime?: number;
};
const INCREMENT_TIME_IN_MS = 300;
const PERIOD_TIME_IN_MS = 30000;

export const ValueTicker: React.FC<ValueTickerProps> = ({
    prevAmount,
    amount,
    incrementTime = INCREMENT_TIME_IN_MS,
    periodTime = PERIOD_TIME_IN_MS
}) => {
    const [currentAmount, setCurrentAmount] = useState(amount);
    const numberOfTicks = periodTime / incrementTime;
    const diff = Math.abs(amount - prevAmount) / numberOfTicks;

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentAmount((prev) => {
                if (prev + diff >= amount) {
                    return amount;
                }

                return prev + diff;
            });
        }, INCREMENT_TIME_IN_MS);

        return () => {
            clearInterval(intervalId);
        };
    }, [diff, amount]);

    useEffect(() => {
        setCurrentAmount(prevAmount);
    }, [prevAmount]);

    return <span>{formatNumberDefault(currentAmount)}</span>;
};
